import { message, TreeSelect } from 'antd';
import { convertSitesToTreeV2 } from '../../Masters/GeneralComponents/Functions';
import React, { useState, useEffect } from 'react'
import { InputWithLabel } from '../../Components/Components';
import axios from 'axios';



export default function SiteTreeSelectAuto({
    selectedOrg,

    value,
    setValue = () => { alert("Site Select setValue method not defined") },

    className = "my-form-input",
    style = { width: "300px" },
    status = "",

    showTreeLine = true,
    showLeafIcon = false,
    initialUnselected = false,
    disabled = false,

    pickerLabel = "Select Site",
    inputErrors = {},
    reqMark = true,
}) {
    const [loading, setLoading] = useState(true);
    // Options for site select
    const [siteTree, setSiteTree] = useState([]);

    // This is the state which will handle Change
    // Then on blur we will set the main state which is responsible for the filter

    const getSiteOptions = async () => {
        setLoading(true);
        await axios.get('/admin-api/all_sites_by_o_id', {
            params: {
                o_id: selectedOrg.orgId,
            }
        })
            .then(res => {
                const data = res.data.data;

                const { treeData, siteIds } = convertSitesToTreeV2(data);

                console.log(treeData);
                // let selectedSiteId = siteIds[0];
                let selectedSiteId
                if (initialUnselected)
                    selectedSiteId = null
                else
                    selectedSiteId = siteIds[0]

                if (siteIds.includes(value)) {
                    selectedSiteId = value;
                }

                setSiteTree(treeData);
                setValue(selectedSiteId);     // Set the siteIds as the value of the select
            })
            .catch(err => {
                setSiteTree([]);
                console.log(err);
                message.error('Error in fetching sites');
            })
        setLoading(false);

    }

    useEffect(() => {
        getSiteOptions();
    }, [selectedOrg.orgId]);





    return (
        <InputWithLabel reqMark={reqMark} label={pickerLabel} error={inputErrors}>
            <TreeSelect
                className={className}
                style={style}

                key={selectedOrg.orgId}

                treeData={siteTree}
                treeLine={showTreeLine && { showLeafIcon }}

                value={value}
                onChange={setValue}
                // maxTagCount={1}
                // maxTagPlaceholder={selectedSites => `+ ${selectedSites.length} more`}
                // treeCheckable={true}

                // showCheckedStrategy={'SHOW_CHILD'}
                placeholder={!loading && "Select Sites"}

                // onBlur={() => setValue(selectedSites)}

                loading={loading}
                disabled={loading || disabled}

                showSearch={true}
                filterTreeNode={(inputValue, treeNode) => {
                    return treeNode.title.toLowerCase().includes(inputValue.toLowerCase());
                }}
            />
        </InputWithLabel>
    )
}
